import { CardBody, Collapse } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { MATUAL_FRIEND_LIST } from "../../../../../Data/SocialApp";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { MyProfileClassCollapseProp } from "../../../../../Type/SocialAppType";

const MutualFriendsCollapase = ({ isFilter }: MyProfileClassCollapseProp) => {
  return (
    <Collapse isOpen={isFilter}>
      <CardBody className="social-status filter-cards-view">
        {MATUAL_FRIEND_LIST.map((data, index) => (
          <div className="d-flex" key={index}>
            <Image className="img-50 rounded-circle m-r-15" src={dynamicImage(`user/${data.imageName}`)} alt="user"/>
            <div className={`social-status ${data.socialClass}`} />
            <div className="flex-grow-1">
              <span className="f-w-600 d-block">{data.title}</span>
              <span className="d-block">{data.email}</span>
            </div>
          </div>
        ))}
      </CardBody>
    </Collapse>
  );
};

export default MutualFriendsCollapase;
